export default "__VITE_ASSET__DRpMoXn6__"